import React, { useMemo } from 'react';
import { useLocation, useNavigate, matchPath } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ROUTE_TITLES: Array<{ pattern: string; title: string }> = [
  { pattern: '/checkout/:gameId', title: 'Checkout' },
  { pattern: '/payment/:orderId', title: 'Payment' },
  { pattern: '/transactions', title: 'Transactions' },
];

function routeToTitle(pathname: string): string {
  for (const { pattern, title } of ROUTE_TITLES) {
    if (matchPath({ path: pattern, end: true }, pathname)) return title;
  }
  return '';
}

const HIDDEN_PATHS = new Set(['/', '/home']);

const MobileBackBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const title = useMemo(() => routeToTitle(location.pathname), [location.pathname]);

  if (HIDDEN_PATHS.has(location.pathname)) return null;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="md:hidden fixed top-0 inset-x-0 z-40 h-11 bg-white border-b border-gray-200 flex items-center px-3 gap-2 shadow-sm">
      <button
        type="button"
        onClick={handleBack}
        className="p-1 -m-1 text-gray-700 hover:text-gray-900 active:opacity-70"
        aria-label="Back"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      {title && (
        <span className="text-sm font-medium text-gray-900 truncate">{title}</span>
      )}
    </div>
  );
};

export default MobileBackBar;
